import useMapStore from "./use-map-store";

const useMap = () => {
  const map = useMapStore((store) => store.map);

  return { map };
};

export default useMap;
